<div class="video-tool-wrapper" [ngStyle]="getContainerStyles()">
  <div
    class="video-tool-wrapper"
    [class.emptySrc]="!entity.attributes.src"
    #videoContainerRef
  ></div>
</div>
